import { render, staticRenderFns } from "./AtualizarSenhaQuiosque.vue?vue&type=template&id=0530d722"
import script from "./AtualizarSenhaQuiosque.vue?vue&type=script&lang=js"
export * from "./AtualizarSenhaQuiosque.vue?vue&type=script&lang=js"
import style0 from "./AtualizarSenhaQuiosque.vue?vue&type=style&index=0&id=0530d722&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports